import React from 'react';
import { Input, Label } from 'reactstrap';

class States extends React.Component {

    getStates = () => {
        const options = [<option key={0} value={''} disabled>Select a State</option>];

        this.props.states.forEach((state, index) => {
            options.push(<option key={index+1} value={state.stateId}>{state.name}</option>);
        });

        return options;
    }

    handleOnChange = (e) => this.props.onChange(e.target.value);

    render() {
        return (
            <React.Fragment>
                <Label>State:</Label>
                <Input name='state' type='select' id='selectState' onChange={this.handleOnChange} value={this.props.value || ''}>
                    {this.getStates()}
                </Input>
            </React.Fragment>
        );
    }
}

export default States;